import { apiFetch} from "apiClient";
import { apiFetch as fetch } from "apiClient";

export const fetchSuperStarInstruments = async (_tabID) => {
    try {
        const res  = await fetch('/api/superstar-instruments/read');
        const data = await res.json();
        return Array.isArray(data) ? data : [];
    } catch (error) {
        console.error('Error fetching SuperStar instruments:', error);
        return [];
    }
};

